export enum TrackingStatusEnum {
  NOT_SHIPPED = 'Not shipped',
  LABEL_CREATED = 'Label created',
  IN_TRANSIT = 'In transit',
  OUT_FOR_DELIVERY = 'Out for delivery',
  DELIVERED = 'Delivered',
  DELAYED = 'Delayed',
  EXCEPTION = 'Exception',
  CANCELLED = 'Cancelled',
  UNAVAILABLE = 'Unavailable',
}
